/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Icsrm_Staatsexamen_Jura21Inputs */

const en__field_enum_icsrm_staatsexamen_jura21 = /** @type {(inputs: _Field_Enum_Icsrm_Staatsexamen_Jura21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staatsexamen Jura`)
};

const de__field_enum_icsrm_staatsexamen_jura21 = /** @type {(inputs: _Field_Enum_Icsrm_Staatsexamen_Jura21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staatsexamen Jura`)
};

/**
* | output |
* | --- |
* | "Staatsexamen Jura" |
*
* @param {_Field_Enum_Icsrm_Staatsexamen_Jura21Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_icsrm_staatsexamen_jura21 = /** @type {((inputs?: _Field_Enum_Icsrm_Staatsexamen_Jura21Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Icsrm_Staatsexamen_Jura21Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_icsrm_staatsexamen_jura21(inputs)
	return de__field_enum_icsrm_staatsexamen_jura21(inputs)
});
export { _field_enum_icsrm_staatsexamen_jura21 as "_field_enum_ICSRM_STAATSEXAMEN_JURA" }